import { useEffect, useState } from 'react';

import { useFetcher } from '@remix-run/react';

import type { Pagination } from '~/interfaces/pagination';
import type { Recommendation } from '~/interfaces/recommendation';

export type LoaderData = {
  boostedRecommendations: Recommendation[];
  recommendations: Recommendation[];
  pagination: Pagination;
  metaTitle?: string;
};

const useSubscribeRecommendations = () => {
  const fetcher = useFetcher();
  const isLoading = fetcher.state === 'loading';

  const [recommendations, setRecommendations] = useState([]);
  const [boostedRecommendations, setBoostedRecommendations] = useState([]);

  // Fetching on initial page load
  useEffect(() => {
    fetcher.load('/recommendations?index&page=1');
  }, []);

  useEffect(() => {
    if (fetcher.data) {
      const { recommendations, boostedRecommendations } = fetcher.data;

      setRecommendations(recommendations);
      setBoostedRecommendations(boostedRecommendations);
    }
  }, [fetcher.data]);

  return {
    isLoading,
    boostedRecommendations,
    recommendations,
  };
};

export default useSubscribeRecommendations;
